import React, { useEffect, useState } from "react";
import { useDropzone } from "react-dropzone";
import FamilyButtons from "../../components/answers/FamilyButtons";
import RecordedAnswers from "../../components/answers/RecordedAnswers";
import FamilyButtonAddModal from "../../components/answers/FamilyButtonAddModal";
import RecordedAnswersAddModal from "../../components/answers/RecordedAnswersAddModal";

const Answers = () => {
  const [active, setActive] = useState("Family buttons");
  const [answers, setAnswers] = useState([]);
  const [familyAnswers, setFamilyAnswers] = useState([]);

  const { isDragActive, isDragAccept, isDragReject } = useDropzone();

  let dropzoneClass = "dropzone";
  if (isDragActive) dropzoneClass += " dropzone-active";
  if (isDragAccept) dropzoneClass += " dropzone-accept";
  if (isDragReject) dropzoneClass += " dropzone-reject";

  const getAllAnswers = async () => {
    try {
      const response = null;
      if (response) {
        setAnswers(response);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getFamilyAnswers = async () => {
    try {
      const response = null;
      if (response) {
        setFamilyAnswers(response);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getAllAnswers();
  }, []);

  useEffect(() => {
    getFamilyAnswers();
  }, []);

  return (
    <div className="container">
      <div className="overview">
        <div className="title">
          <ion-icon name="bag-check-outline"></ion-icon>
          <span className="text">Answers to questions</span>
        </div>
      </div>

      <div className="d-flex justify-content-between">
        <div className="d-flex">
          <div
            onClick={() => setActive("Family buttons")}
            className={`usersNav ${
              active == "Family buttons" && "usersNav-active"
            }`}
          >
            Family buttons
          </div>
          <div
            onClick={() => setActive("Recorded answers")}
            className={`ms-4 usersNav ${
              active == "Recorded answers" && "usersNav-active"
            }`}
          >
            Recorded answers
          </div>
        </div>
        <div>
          {active == "Family buttons" ? (
            <button
              style={{ marginTop: "0px" }}
              className="btn-header d-flex align-items-center justify-content-end gap-1 ms-auto"
              data-bs-target="#addFamilyMember"
              data-bs-toggle="modal"
            >
              <ion-icon name="add-outline"></ion-icon>
              Add family member
            </button>
          ) : (
            <button
              style={{ marginTop: "0px" }}
              className="btn-header d-flex align-items-center justify-content-end gap-1 ms-auto"
              data-bs-target="#AddRecordedAnswers"
              data-bs-toggle="modal"
            >
              <ion-icon name="add-outline"></ion-icon>
              Add recorded Answer
            </button>
          )}
        </div>
      </div>

      {active == "Family buttons" ? (
        <FamilyButtons answers={familyAnswers} />
      ) : (
        <RecordedAnswers answers={answers} characters={familyAnswers} />
      )}

      {/* Add recorded answer modal */}
      <div
        className="modal fade"
        id="AddRecordedAnswers"
        tabIndex="-1"
        aria-labelledby="exampleModalToggleLabel"
        aria-hidden="true"
      >
        <RecordedAnswersAddModal characters={familyAnswers} type="add" />
      </div>

      {/* Add family member */}

      <div
        className="modal fade"
        id="addFamilyMember"
        tabIndex="-1"
        aria-labelledby="exampleModalToggleLabel"
        aria-hidden="true"
      >
        <FamilyButtonAddModal type="add" />
      </div>
    </div>
  );
};

export default Answers;
